// extracted by mini-css-extract-plugin
export default {"inputBlock":"hDiELNtv1y4UrU6JJfCv"};